module.exports = __webpack_public_path__ + "media/images/img_map_nihonbashi-c6fa04c6185823839ddead0db543ffd8.png";